// extracted by mini-css-extract-plugin
module.exports = {"Bold":"Bold-39wKG","SemiBold":"SemiBold-3KS_K","Medium":"Medium-3YrBq","Razzmatazz":"Razzmatazz-2kwZ3"};